import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { Container as u, LikeIcon as m, FunnyIcon as s, HelpfulIcon as f, Counter as p } from "./style.js";
import { useTranslation as h } from "../../../../hooks/useTranslation/index.js";
import { ThumbsUp as b, FaceLaughSquint as k, SquareCheck as C } from "@pelando/fontawesome/icons";
const j = ({
  reactions: i,
  ...r
}) => {
  const { t: n } = h("common");
  if (!i)
    return null;
  const { funny: t, helpful: e, like: c } = i;
  if (!t && !e && !c)
    return null;
  const l = t + e + c;
  return /* @__PURE__ */ a(
    u,
    {
      title: n("comment-reaction-counter-title"),
      "aria-label": n("comment-reaction-counter-title"),
      ...r,
      children: [
        !!c && /* @__PURE__ */ o(
          m,
          {
            icon: b,
            "aria-label": n("comment-actions-counter-like-icon")
          }
        ),
        !!t && /* @__PURE__ */ o(
          s,
          {
            icon: k,
            "aria-label": n("comment-actions-counter-funny-icon")
          }
        ),
        !!e && /* @__PURE__ */ o(
          f,
          {
            icon: C,
            "aria-label": n("comment-actions-counter-helpful-icon")
          }
        ),
        /* @__PURE__ */ o(p, { children: l })
      ]
    }
  );
};
export {
  j as ReactionsCounter
};
